const audFormatter = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' });
const dateTimeFormatter = new Intl.DateTimeFormat('en-AU', { dateStyle: 'medium', timeStyle: 'short' });

export function formatAud(amount: string): string {
  return audFormatter.format(Number(amount));
}

export function formatDateTime(iso: string): string {
  return dateTimeFormatter.format(new Date(iso));
}
